import { 
  RouterProvider,
  createBrowserRouter
} from 'react-router-dom'
import Form from './pages/form'
import Success from './pages/success'

const router = createBrowserRouter([
  {
    path: '/:oid',
    element: <Form />,
  },
  {
    path: '/:oid/success',
    element: <Success />,
  }
])

export default function Router() {
  return (
    <RouterProvider router={router} />
  )
}
